export const SERVICE_TYPES = [
  { id: 'passeio_diario', name: 'Passeio Diário', icon: 'Dog', description: 'Passeio diário para o seu cão' },
  { id: 'hospedagem', name: 'Hospedagem', icon: 'House', description: 'Hospedagem em casa do pet sitter' },
  { id: 'visita_domicilio', name: 'Visita ao Domicílio', icon: 'MapPin', description: 'Visitas à sua casa para alimentar e brincar' },
  { id: 'dog_sitting', name: 'Dog Sitting', icon: 'Heart', description: 'Cuidados durante viagens ou ausências' },
];

export const DAYS_OF_WEEK = [
  { id: 0, name: 'Segunda', short: 'Seg' },
  { id: 1, name: 'Terça', short: 'Ter' },
  { id: 2, name: 'Quarta', short: 'Qua' },
  { id: 3, name: 'Quinta', short: 'Qui' },
  { id: 4, name: 'Sexta', short: 'Sex' },
  { id: 5, name: 'Sábado', short: 'Sáb' },
  { id: 6, name: 'Domingo', short: 'Dom' },
];

export const TIME_SLOTS = [
  '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30',
  '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30',
  '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30',
  '19:00', '19:30', '20:00', '20:30', '21:00',
];


export const CITIES = [
  { id: 'albufeira', name: 'Albufeira', lat: 37.0882, lng: -8.2503 },
  { id: 'almada', name: 'Almada', lat: 38.6790, lng: -9.1565 },
  { id: 'amadora', name: 'Amadora', lat: 38.7538, lng: -9.2305 },
  { id: 'aveiro', name: 'Aveiro', lat: 40.6405, lng: -8.6538 },
  { id: 'braga', name: 'Braga', lat: 41.5454, lng: -8.4265 },
  { id: 'cascais', name: 'Cascais', lat: 38.6979, lng: -9.4215 },
  { id: 'coimbra', name: 'Coimbra', lat: 40.2033, lng: -8.4103 },
  { id: 'evora', name: 'Évora', lat: 38.5667, lng: -7.9 },
  { id: 'faro', name: 'Faro', lat: 37.0194, lng: -7.9322 },
  { id: 'funchal', name: 'Funchal', lat: 32.6669, lng: -16.9241 },
  { id: 'guimaraes', name: 'Guimarães', lat: 41.4425, lng: -8.2918 },
  { id: 'leiria', name: 'Leiria', lat: 39.7436, lng: -8.8071 },
  { id: 'lisboa', name: 'Lisboa', lat: 38.7223, lng: -9.1393 },
  { id: 'loures', name: 'Loures', lat: 38.8300, lng: -9.1685 },
  { id: 'oeiras', name: 'Oeiras', lat: 38.6913, lng: -9.3117 },
  { id: 'portimao', name: 'Portimão', lat: 37.1366, lng: -8.5378 },
  { id: 'porto', name: 'Porto', lat: 41.1579, lng: -8.6291 },
  { id: 'setubal', name: 'Setúbal', lat: 38.5244, lng: -8.8882 },
  { id: 'sintra', name: 'Sintra', lat: 38.8029, lng: -9.3817 },
  { id: 'vila_nova_de_gaia', name: 'Vila Nova de Gaia', lat: 41.1239, lng: -8.6118 },
  { id: 'viseu', name: 'Viseu', lat: 40.6610, lng: -7.9097 },
];

export const SPECIES = [
  { id: 'cao', name: 'Cão' },
  { id: 'gato', name: 'Gato' },
];

export const REQUEST_STATUS = {
  pending: { label: 'Pendente', color: 'bg-yellow-100 text-yellow-800' },
  accepted: { label: 'Aceite', color: 'bg-green-100 text-green-800' },
  rejected: { label: 'Recusado', color: 'bg-red-100 text-red-800' },
  completed: { label: 'Concluído', color: 'bg-blue-100 text-blue-800' },
  cancelled: { label: 'Cancelado', color: 'bg-gray-100 text-gray-800' },
};

export const WEEKDAYS = [
  { id: 0, name: 'Domingo', short: 'Dom' },
  { id: 1, name: 'Segunda', short: 'Seg' },
  { id: 2, name: 'Terça', short: 'Ter' },
  { id: 3, name: 'Quarta', short: 'Qua' },
  { id: 4, name: 'Quinta', short: 'Qui' },
  { id: 5, name: 'Sexta', short: 'Sex' },
  { id: 6, name: 'Sábado', short: 'Sáb' },
];

export const HOURS = Array.from({ length: 24 }, (_, i) => ({
  value: i,
  label: `${i.toString().padStart(2, '0')}:00`,
}));

export function getServiceName(serviceId) {
  const service = SERVICE_TYPES.find(s => s.id === serviceId);
  return service?.name || serviceId;
}

export function getCityName(cityId) {
  const city = CITIES.find(c => c.id === cityId);
  return city?.name || cityId;
}

export function getCityCoords(cityId) {
  const city = CITIES.find(c => c.id === cityId);
  return city ? { lat: city.lat, lng: city.lng } : { lat: 38.7223, lng: -9.1393 };
}

export function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-PT', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function formatDateTime(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-PT', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatPrice(price) {
  return new Intl.NumberFormat('pt-PT', {
    style: 'currency',
    currency: 'EUR',
  }).format(price);
}

export function formatRelativeTime(dateString) {
  const date = new Date(dateString);
  const now = new Date();
  const diff = now - date;
  
  const minutes = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days = Math.floor(diff / 86400000);
  
  if (minutes < 1) return 'Agora mesmo';
  if (minutes < 60) return `Há ${minutes} minuto${minutes !== 1 ? 's' : ''}`;
  if (hours < 24) return `Há ${hours} hora${hours !== 1 ? 's' : ''}`;
  if (days < 7) return `Há ${days} dia${days !== 1 ? 's' : ''}`;
  
  return formatDate(dateString);
}
